import { render, staticRenderFns } from "./CalendarHome.vue?vue&type=template&id=461245ab&scoped=true"
import script from "./CalendarHome.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarHome.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461245ab",
  null
  
)

export default component.exports